<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    ref="pagelist"
    :export-data-options="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'BillRateSetBindingsList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
    rateSetId: String,
    data: Object,
    ratesetColumns: Array,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: `ratesets/${this.rateSetId}/bindings`,
        apiVersion: 'v1',
        getParams: {
          details: true,
        },
        hiddenColumns: ['id'],
      }),
      columns: [
        {
          field: 'type',
          title: this.$t('bill.rateset.scope'),
          formatter: ({ row }) => {
            const { type } = row
            return this.$t(`bill.rateset.scope.${type}`)
          },
        },
        {
          field: 'bind_name',
          title: this.$t('bill.rateset.scope_info'),
          formatter: ({ row }) => {
            const { type, bind_name, bind_tags = [] } = row
            if (type === 'project' || type === 'domain') return bind_name
            if (type === 'organization') {
              const list = bind_tags.map(item => this.getTag(item))
              return list.join(' - ')
            }
          },
        },
      ],
      groupActions: [
        {
          label: this.$t('bill.bind'),
          permission: 'ratesets_perform_bind',
          action: () => {
            this.createDialog('RatesetBindDialog', {
              columns: this.ratesetColumns,
              data: [this.data],
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('bill.unbind'),
          permission: 'ratesets_perform_unbind',
          action: () => {
            this.createDialog('RatesetUnbindDialog', {
              columns: this.columns,
              data: this.list.selectedItems,
              rateSetId: this.data.id,
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              validate: !!this.list.selectedItems.length,
            }
          },
        },
      ],
      singleActions: [
        {
          label: this.$t('bill.unbind'),
          permission: 'ratesets_perform_unbind',
          action: (row) => {
            this.createDialog('RatesetUnbindDialog', {
              columns: this.columns,
              data: [row],
              rateSetId: this.data.id,
              refresh: this.refresh,
            })
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: this.$t('bill.rateset.scope'),
        downloadType: 'local',
        items: this.columns,
      }
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    getTag (tag) {
      const { key, value } = tag
      if (value) {
        return `${key.replace('org:', '')}:${value}`
      } else {
        return key.replace('org:', '')
      }
    },
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillRateSetSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
      })
    },
  },
}
</script>
